import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedModule } from '@/shared.module';

/**
 * Read-only dialog explaining how to fill in the notes textarea of an
 * interventie: how to operationalise the activity for this zorgvrager, plan
 * it, safeguard it and divide the work, and why. Opened from the info icon in
 * the interventions section; closes without a result.
 */
@Component({
  selector: 'app-nnn-interventions-info-dialog',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './nnn-interventions-info-dialog.component.html',
  styleUrl: './nnn-interventions-info-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NnnInterventionsInfoDialogComponent {
  protected readonly sections = [
    { key: 'operationalisation', hasWhy: true },
    { key: 'planning', hasWhy: true },
    { key: 'safety', hasWhy: true },
    { key: 'collaboration', hasWhy: false },
  ] as const;
}
